import React from "react";

import {

    Bike

} from "lucide-react";

import "./WaitingForOrders.css";

function WaitingForOrders() {

    return (

        <div className="waiting-card">

            <div className="bike-animation">

                <Bike
                    size={70}
                />

            </div>

            <h2>

                Waiting for Orders...

            </h2>

            <p>

                Stay online to receive nearby delivery requests.

            </p>

            <div className="loading-line">

                <div className="loading-progress"></div>

            </div>

        </div>

    );

}

export default WaitingForOrders;